export const notificationSnackBarAction = async ({ commit }, payload) => {
  commit('notificationSnackBarMutator', payload)
}

export const notificationDialogAction = async ({ commit }, payload) => {
  commit('notificationDialogMutator', payload)
}
